import React, {useState, ChangeEvent} from "react";

interface Props {
    currentHomeProbability: string;
    currentAwayProbability: string;
    changeHomeProbability: (val: string) =>void;
    changeAwayProbability: (val: string) => void;
    changeTargetTeam: (val: number) => void; // 0 is home, 1 is away
}

const InputProbability: React.FC<Props> = ({changeHomeProbability, changeAwayProbability, changeTargetTeam, currentHomeProbability, currentAwayProbability}) => {
  
    const [homeProbability, setHomeProbability] = useState(currentHomeProbability.toString());
    const [awayProbability, setAwayProbability] = useState(currentAwayProbability.toString());
    const [targetTeam, setTargetTeam] = useState(0);

    const handleHomeInput = (event: ChangeEvent<HTMLInputElement>) => {
      let { value, min, max } = event.target;
      value = Math.max(Number(min), Math.min(Number(max), Number(value))).toString();
      console.log(value);
      changeHomeProbability(value);
      setHomeProbability(value);
      changeAwayProbability((100 - Number(value)).toString());
      setAwayProbability((100 - Number(value)).toString());

    };

    const handleAwayInput = (event: ChangeEvent<HTMLInputElement>) => {
      let { value, min, max } = event.target;
      value = Math.max(Number(min), Math.min(Number(max), Number(value))).toString();
      changeAwayProbability(value);
      setAwayProbability(value);
      changeHomeProbability((100 - Number(value)).toString());
      setHomeProbability((100 - Number(value)).toString());
    }
  return (
    
    <div className="grid grid-rows-6 gap-4">
      <div className="rounded-md row-span-1 flex items-center justify-center font-bold">
        Enter the desired winning probabilities
      </div>
      <div className="border border-gray-300 rounded-md p-2 row-span-5">
        {/**
         * 
         * Radio that selects either home or away
         * 
         */}
        <div className="flex flex-row items-center justify-center">
          <input
            type="radio"
            name="target"
            id="home"
            className="mr-2"
            onClick={() => {
              changeTargetTeam(0);
              setTargetTeam(0);
            }}
            
            defaultChecked
          />
          <label htmlFor="home">Home Team</label>
          <input
            type="radio"
            name="target"
            id="away"
            className="ml-4 mr-2"
            onClick={() => {
              changeTargetTeam(1);
              setTargetTeam(1);
            }}

            
          />
          <label htmlFor="away">Away Team</label>
        </div>
        <div className="border border-gray-300 rounded-md m-3 p-3 bg-neutral-400 flex flex-col items-center justify-center">
          <h3 className="font-bold">{targetTeam === 0 ? "Home" : "Away"} Team Probability</h3>
          <div className="col-span-1 mx-2 my-2 flex flex-row items-center justify-center">

          <input
            type="number"
            max="100"
            min="0"
            placeholder={targetTeam === 0 ? currentHomeProbability : currentAwayProbability}
            className="border border-gray-300 rounded-md py-2 px-3 text-md"
            onChange={targetTeam === 0 ? handleHomeInput : handleAwayInput}
            value={targetTeam === 0 ? homeProbability : awayProbability}
          />
          <span className="text-md font-bold ml-2">%</span>

          </div>
          <h3 className="font-bold">{targetTeam === 1 ? "Home" : "Away"} Team Probability</h3>
          <p className="text-md font-bold">{targetTeam === 0 ? awayProbability : homeProbability}%</p>
        </div>
      </div>
    </div>
  );
};
export default InputProbability;
